export const PointLoyaltyRuleType = (json: IPointLoyaltyRulesType): IPointLoyaltyRulesTypeModel => {
	const { ...rest } = json

	return {
		...rest,
	}
}

export const PointsLoyaltyRule = (json: IPointLoyaltyRules): IPointLoyaltyRulesModel => {
	const { ...rest } = json

	return {
		...rest,
	}
}

/**
 * Paylods
 */
const PointsLoyaltyRuleSharedPayload = (
	event: IFormSubmitEvent<IPointLoyaltyRulesForm>,
): IPointLoyaltyRulesSharedPayload => {
	const { rule } = event.values

	return {
		type: rule,
		configuration: {},
	}
}

export const PointsLoyaltyRuleCreateToPayload = (event: IFormSubmitEvent<IPointLoyaltyRulesForm>) => {
	const shared = PointsLoyaltyRuleSharedPayload(event)

	return {
		...shared,
	}
}

export const PointsLoyaltyRuleUpdateToPayload = (
	updated: IPointLoyaltyRulesModel,
	event: IFormSubmitEvent<IPointLoyaltyRulesForm>,
) => {
	const shared = PointsLoyaltyRuleSharedPayload(event)

	return {
		...shared,
		id: updated.id,
	}
}
